/**
 * AppShell — khung layout admin: Sidebar (epic-grouped) + Topbar (search/notif/theme/lang)
 * + main. Semantic HTML (aside/header/main). US-AE.F0-0000-S04 (redesign theo design handoff).
 *
 * Nhận `children` (router bọc qua withShell). Breadcrumb suy từ pathname theo NAV.
 * @AF0.0
 */
import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Sidebar } from "./Sidebar.js";
import { Topbar } from "./Topbar.js";
import { resolveCrumbKeys } from "./nav.js";

export interface AppShellProps {
  readonly children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  // resolveCrumbKeys: longest-match (fix bug '/billing/usage' dừng ở cha '/billing').
  const { group, pageKey } = resolveCrumbKeys(pathname);

  return (
    <div className="flex min-h-screen w-full">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar crumbGroup={t(group)} crumbPage={t(pageKey)} />
        <main className="gp-scroll flex-1 overflow-y-auto">
          <div className="mx-auto max-w-[1320px] px-7 pb-16 pt-[26px]">{children}</div>
        </main>
      </div>
    </div>
  );
}

/** Header trang chuẩn (title + desc + optional action). */
export function PageHeader({
  title,
  desc,
  action,
}: {
  title: string;
  desc?: string;
  action?: ReactNode;
}) {
  return (
    <div className="mb-[18px] flex items-start justify-between gap-4">
      <div className="min-w-0">
        <h1 className="m-0 mb-1 text-[21px] font-semibold tracking-[-.02em]">{title}</h1>
        {desc && <p className="m-0 max-w-[680px] text-[13.5px] text-fg-muted">{desc}</p>}
      </div>
      {action}
    </div>
  );
}
